'use client'

import { useState } from 'react'

import { clsx } from 'clsx'

import { Copy } from 'shared-components'

import BlockArrow from '../../../images/blockArrow'

import s from './Accordion2Column.module.sass'

function Accordion({ items }: any) {
    const [openIndex, setOpenIndex] = useState<number>(0)

    if (!items || items.length === 0) {
        return null
    }

    const handleToggle = (index: number) => {
        if (openIndex === index) {
            setOpenIndex(-1)
        } else {
            setOpenIndex(index)
        }
    }

    return (
        <div className={s.Accordion}>
            {items.map((item: any, index: number) => {
                const {
                    title,
                    copy,
                } = item

                return (
                    <div key={index} className={clsx(s.Item, openIndex === index && s.Open)}>
                        <div className={s.Title} onClick={() => handleToggle(index)}>
                            {title && <h5 dangerouslySetInnerHTML={{ __html: title }} />}
                            {BlockArrow}
                        </div>
                        {copy && (
                            <div className={s.Copy}>
                                <div>
                                    <Copy copy={copy} size='small' />
                                </div>
                            </div>
                        )}
                    </div>
                )
            })}
        </div>
    )
}

export default Accordion
